'use client';

import { useRef } from 'react';

import BasePlayer, {
  type YouTubeProps as BasePlayerProps,
} from 'react-youtube';

import { usePauseVideo } from './hooks';

interface YoutubePlayerProps
  extends Required<Pick<BasePlayerProps, 'videoId'>> {
  className?: string;
  title: string;
  isActive: boolean;
  autoplay?: boolean;
  onPlay?: () => void;
}

function YoutubePlayer(props: Readonly<YoutubePlayerProps>) {
  const { className, title, isActive, autoplay, onPlay, videoId } = props;

  const ref = useRef<BasePlayer>(null);

  usePauseVideo({
    playerRef: ref,
    isActive,
  });

  return (
    <BasePlayer
      className={className}
      title={title}
      ref={ref}
      videoId={videoId}
      id={videoId}
      opts={{
        playerVars: {
          autoplay: autoplay && isActive ? 1 : 0,
        },
      }}
      onPlay={onPlay}
    />
  );
}

export default YoutubePlayer;
